import store from '../utils/store';
import got from '../utils/request';


export default {
    getUserInfo,
    login,
    logout,
    getRandomMsg,
    getPrice,
    getTransactionList,
    purchase,
    submitInviteCode,
    getInvitationList
};

async function login(address) {
    if (!address) {
        address = store.get('addr');
    }
    let ret = await got("/dao/login", { address });
    if (ret.msg == 'ok' && ret.data.token && ret.data.account) {
        store.set('token', ret.data.token);
        store.set('user-info', ret.data.account);
        store.set('token-addr',address);
    }
    return ret;
}
async function getUserInfo(address) {
    if (!address) {
        address = store.get('addr');
    }
    let ret = await got("/dao/user", { address });
    if (ret.msg == 'ok' && ret.data) {
        store.set('user-info', ret.data);
    }
    return ret;
}
async function checkToken(ret) {
    // if (ret.msg == 'Please relogin.') {
    //     let info = store.get("user-info");
    //     let address = info.address;
    //     let ret=await getRandomMsg(address);

    //     await login(address,)
    // }
    return ret;
}
async function logout() {
    store.remove('token');
    store.remove('user-info');
}
async function getRandomMsg(address) {
    if (!address) {
        address = store.get('addr');
    }
    let ret = await got("/dao/magic-msg", { address });
    return ret;
}
async function getPrice() {
    let ret = await got("/dao/addr", { a: 1 });
    return await checkToken(ret);
}
async function getTransactionList(address) {
    if (!address) {
        address = store.get('addr');
    }
    let ret = await got("/dao/transactions", { address });
    return await checkToken(ret);
}
async function purchase(address, to, amount, txhash) {
    if (!address) {
        address = store.get('addr');
    }
    let ret = await got("/dao/purchase", { address, to, amount, txhash });
    return await checkToken(ret);
}
async function submitInviteCode(address, code) {
    if (!address) {
        address = store.get('addr');
    }
    let ret = await got("/dao/invited", { address, code });
    return await checkToken(ret);
}
async function getInvitationList(address) {
    if (!address) {
        address = store.get('addr');
    }
    let ret = await got("/dao/invitations", { address });
    return await checkToken(ret);
}